/* =========================================================================
   Product Features carousel — Mobile only (below 990px)
   - Native scroll-snap drives swipe gestures.
   - JS keeps dot indicators and arrow enabled-state in sync with scroll.
   - Prev / next arrows scroll smoothly to neighbouring slides.
   - Dot clicks jump straight to the matching slide.
   ========================================================================= */

(function () {
  var SECTION_SELECTOR = '.oddit-section-product-features';
  var DESKTOP_MEDIA_QUERY = '(min-width: 990px)';

  function initSection(section) {
    if (!section || section.dataset.odditCarouselInit === 'true') return;
    section.dataset.odditCarouselInit = 'true';

    var track = section.querySelector('.oddit-section-product-features__cards');
    if (!track) return;

    var slides = Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-product-features__card')
    );
    if (slides.length === 0) return;

    var dots = Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-product-features__dot')
    );
    var prevBtn = section.querySelector(
      '.oddit-section-product-features__arrow--prev'
    );
    var nextBtn = section.querySelector(
      '.oddit-section-product-features__arrow--next'
    );

    var desktopMq = window.matchMedia(DESKTOP_MEDIA_QUERY);

    function getSlideStep() {
      // Distance between the start of one slide and the next, in CSS pixels.
      if (slides.length < 2) return slides[0] ? slides[0].offsetWidth : 0;
      return Math.max(slides[1].offsetLeft - slides[0].offsetLeft, 1);
    }

    function getCurrentIndex() {
      var step = getSlideStep();
      if (step <= 0) return 0;
      // The track's max scrollLeft (scrollWidth - clientWidth) is smaller than
      // step * (slides.length - 1), so once the user has scrolled to the last
      // slide the simple round() math reports the second-to-last index. Detect
      // end-of-scroll explicitly and lock to the final slide.
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll > 0 && track.scrollLeft >= maxScroll - 1) {
        return slides.length - 1;
      }
      var idx = Math.round(track.scrollLeft / step);
      if (idx < 0) idx = 0;
      if (idx > slides.length - 1) idx = slides.length - 1;
      return idx;
    }

    function updateNav() {
      if (desktopMq.matches) return;
      var idx = getCurrentIndex();

      for (var i = 0; i < dots.length; i++) {
        if (i === idx) {
          dots[i].classList.add('is-active');
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].classList.remove('is-active');
          dots[i].removeAttribute('aria-current');
        }
      }

      if (prevBtn) {
        if (idx > 0) {
          prevBtn.classList.add('is-enabled');
          prevBtn.disabled = false;
        } else {
          prevBtn.classList.remove('is-enabled');
          prevBtn.disabled = true;
        }
      }

      if (nextBtn) {
        if (idx < slides.length - 1) {
          nextBtn.classList.add('is-enabled');
          nextBtn.disabled = false;
        } else {
          nextBtn.classList.remove('is-enabled');
          nextBtn.disabled = true;
        }
      }
    }

    function goToIndex(index) {
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;
      var target = slides[index];
      if (!target) return;
      var step = getSlideStep();
      track.scrollTo({
        left: step * index,
        behavior: 'smooth'
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        // Throttle via rAF so we only run once per frame.
        if (track.dataset.scrollScheduled === 'true') return;
        track.dataset.scrollScheduled = 'true';
        requestAnimationFrame(function () {
          track.dataset.scrollScheduled = 'false';
          updateNav();
        });
      },
      { passive: true }
    );

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToIndex(getCurrentIndex() - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToIndex(getCurrentIndex() + 1);
      });
    }

    for (var i = 0; i < dots.length; i++) {
      (function (idx) {
        dots[i].addEventListener('click', function () {
          goToIndex(idx);
        });
      })(i);
    }

    function handleViewportChange() {
      if (desktopMq.matches) {
        // Reset scroll position so re-entering mobile starts fresh.
        track.scrollLeft = 0;
      }
      updateNav();
    }

    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', handleViewportChange);
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(handleViewportChange);
    }

    updateNav();
  }

  function initAll() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector
      ? e.target.querySelector(SECTION_SELECTOR)
      : null;
    if (section) initSection(section);
  });
})();